export function formatTemperature(
  t: number,
  minimumFractionDigits: number = 1,
  maximumFractionDigits: number = minimumFractionDigits,
) {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'decimal',
    minimumFractionDigits,
    maximumFractionDigits,
  });

  return `${formatter.format(t)} °C`;
}
